import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE, USER_ALREADY_REGISTERED } from '../constants';

const initialState = {
  loading: false,
  error: null,
  success: false,
  userAlreadyExists: false,
  userId: null,
};

const signupReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIGNUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
        userAlreadyExists: false,
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        userId: action.payload.userId,
      };
    case SIGNUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case USER_ALREADY_REGISTERED:
      return {
        ...state,
        loading: false,
        userAlreadyExists: true,
      };
    default:
      return state;
  }
};

export default signupReducer;